/*
Want to customize your button? visit our documentation page:https://login.equalweb.com/custom-button.taf
*/
window.interdeal = {
  "sitekey": "1f271a4819393ac083d5720beec9dbf1",
  "Position": "left",
  "domains": {
    "js": "https://cdn.equalweb.com/",
    "acc": "https://access.equalweb.com/"
  },
  "Menulang": "EN",
  "btnStyle": {
    "vPosition": [
      "80%",
      "80%"
    ],
    "scale": [
      "0.5",
      "0.5"
    ],
    "color": {
      "main": "#BF5321",
      "second": "#ffffff"
    },
    "icon": {
      "outline": false,
      "type": 4,
      "shape": "circle"
    }
  }
};
(function(doc, head, body){
  var coreCall             = doc.createElement('script');
  coreCall.src             = interdeal.domains.js + 'core/5.0.10/accessibility.js';
  coreCall.defer           = true;
  coreCall.integrity       = 'sha512-gKQdQe59Hw864B9Pbxo+0aPeJJQdKODsfg0Vwf+zIQcRS7uR+kd3oEX3ClAdDERLQbO5LmliXmzjNjrxkP5wgA==';
  coreCall.crossOrigin     = 'anonymous';
  coreCall.setAttribute('data-cfasync', true );
  body? body.appendChild(coreCall) : head.appendChild(coreCall);
})(document, document.head, document.body);